var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHambergerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1",
    "data-name": "\\uC0AC\\uAC01\\uD615 1",
    d: "M5,7H40v4H5V7ZM5,20H40v4H5V20ZM5,34H40v4H5V34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHambergerMenu);
export default __webpack_public_path__ + "static/media/hambergerMenu.10a397a34601797de069752bc9a55069.svg";
export { ForwardRef as ReactComponent };